import Router from 'vue-router'
import Vue from 'vue'
import protectedRoutes from '@/router/protected'
import publicRoutes from '@/router/public'
import store from '@/store'
import {repositoryFactory} from '@/repositories/repositoryFactory'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    scrollBehavior() {
        return window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    routes: [
        ...publicRoutes,
        ...protectedRoutes
    ]
})

router.beforeEach((to, from, next) => {
    const fromRoute = from.path ? from.path.split('/') : []
    const toRoute = to.path ? to.path.split('/') : []

    if (fromRoute[1] !== toRoute[1] && fromRoute[2] !== toRoute[2]) {
        store.dispatch('setRouterInfo', null)
    }

    if (to.matched.some(record => record.meta.requiresAuth)) {
        const autenticacao = store.getters.getAutenticacao

        if (autenticacao === null || autenticacao.token === null) {
            const customer = store.getters.getCustomer

            if (customer) {
                next(`/login/${customer.link}`)
            }

            next('/401')
        }
    }

    if (store.getters.getShowExitFormConfirmation) {
        store.dispatch('notification/createNotification', {
            type: 'dialog',
            color: 'danger',
            title: 'Atenção',
            message: 'As informações não salvas serão perdidas. Deseja realmente sair?',
            confirm: async () => {
                store.dispatch('unsetShowExitFormConfirmation')
                next()
            },
        })
    } else {
        next()
    }
})

router.afterEach((to, from) => {
    const repository = repositoryFactory.get('conectaSus.routerInfo')

    const fromRoute = from.path ? from.path.split('/') : []
    const toRoute = to.path ? to.path.split('/') : []

    if (from.path.includes('login') || to.path.includes('login')) {
        return
    }

    if (toRoute.length < 3) {
        return
    }

    if (fromRoute[1] === toRoute[1] && fromRoute[2] === toRoute[2]) {
        return
    }

    repository
        .store({modulo: toRoute[1], funcionalidade: toRoute[2]})
        .then(response => store.dispatch('setRouterInfo', response.data))
        .catch(() => {})
})

export default router